import { useLayoutEffect, useRef, useState } from 'react';

type WidthMap = Record<string, number>;

export function useFixedHeaderWidths(fixedIds: string[]) {
  const headerRefs = useRef<Record<string, HTMLTableCellElement | null>>({});
  const [widths, setWidths] = useState<WidthMap>({});

  // stable ref callback for each header
  const getHeaderRef = (id: string) => (el: HTMLTableCellElement | null) => {
    if (el) {
      headerRefs.current[id] = el;
    }
  };

  // measure widths once headers are rendered
  useLayoutEffect(() => {
    const newWidths: WidthMap = {};
    fixedIds.forEach((id) => {
      const el = headerRefs.current[id];
      if (el) {
        newWidths[id] = el.getBoundingClientRect().width;
      }
    });

    // update only if changed
    setWidths((prev) => {
      const same =
        Object.keys(prev).length === Object.keys(newWidths).length &&
        Object.keys(prev).every((k) => prev[k] === newWidths[k]);
      return same ? prev : newWidths;
    });
  }, [fixedIds]);

  return { getHeaderRef, widths };
}
